import { Relationships } from '@leverege/molten/data-source';
import { GlobalState } from '@leverege/ui-redux';
import { Types } from "../../../../constants/index.js";
import DeviceGroupGroupDelegate from "../../../../delegates/deviceGroup/DeviceGroupGroupDelegate.js";
import DeviceTypeGroupDelegate from "../../../../delegates/deviceType/DeviceTypeGroupDelegate.js";
import FirmwareApplicationGroupDelegate from "../../../../delegates/firmwareApplication/FirmwareApplicationGroupDelegate.js";
import FirmwareComponentGroupDelegate from "../../../../delegates/firmwareComponent/FirmwareComponentGroupDelegate.js";
export default {
  install(molten) {
    molten.addPlugin('FotaAttrValueOptions', {
      type: Types.deviceType,
      // eslint-disable-next-line no-empty-pattern
      getOptions: ({
        /* attr, actions, relationship */limit,
        offset
      }) => {
        // TODO: make this work besides at the root
        const relationship = Relationships.getByPath('leverege.fotaApi.deviceType');
        const deviceTypeActions = new DeviceTypeGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        return GlobalState.dispatch(deviceTypeActions.list({
          limit,
          offset
        }));
      },
      getOption: async ({
        id
      }) => {
        const relationship = Relationships.getByPath('leverege.fotaApi.deviceType');
        const deviceTypeActions = new DeviceTypeGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        if (deviceTypeActions.getItem(id)) {
          return deviceTypeActions.getItem(id);
        }
        return GlobalState.dispatch(deviceTypeActions.get(id));
      }
    });
    molten.addPlugin('FotaAttrValueOptions', {
      type: Types.deviceGroup,
      // eslint-disable-next-line no-empty-pattern
      getOptions: ({
        /* attr, actions, relationship */limit,
        offset
      }) => {
        // TODO: make this work besides at the root
        const relationship = Relationships.getByPath('leverege.fotaApi.deviceGroup');
        const deviceGroupActions = new DeviceGroupGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        return GlobalState.dispatch(deviceGroupActions.list({
          limit,
          offset
        }));
      },
      getOption: async ({
        id
      }) => {
        const relationship = Relationships.getByPath('leverege.fotaApi.deviceGroup');
        const deviceGroupActions = new DeviceGroupGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        if (deviceGroupActions.getItem(id)) {
          return deviceGroupActions.getItem(id);
        }
        return GlobalState.dispatch(deviceGroupActions.get(id));
      }
    });
    molten.addPlugin('FotaAttrValueOptions', {
      type: Types.firmwareApplication,
      // eslint-disable-next-line no-empty-pattern
      getOptions: ({
        /* attr, actions, relationship */limit,
        offset,
        query
      }) => {
        // TODO: make this work besides at the root
        const relationship = Relationships.getByPath('leverege.fotaApi.firmwareApplication');
        const firmwareApplicationActions = new FirmwareApplicationGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        return GlobalState.dispatch(firmwareApplicationActions.list({
          limit,
          offset,
          ...query
        }));
      },
      getOption: async ({
        id
      }) => {
        const relationship = Relationships.getByPath('leverege.fotaApi.firmwareApplication');
        const firmwareApplicationActions = new FirmwareApplicationGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        if (firmwareApplicationActions.getItem(id)) {
          return firmwareApplicationActions.getItem(id);
        }
        return GlobalState.dispatch(firmwareApplicationActions.get(id));
      }
    });
    molten.addPlugin('FotaAttrValueOptions', {
      type: Types.firmwareComponent,
      // eslint-disable-next-line no-empty-pattern
      getOptions: ({
        /* attr, actions, relationship */limit,
        offset
      }) => {
        // TODO: make this work besides at the root
        const relationship = Relationships.getByPath('leverege.fotaApi.firmwareComponent');
        const firmwareComponentActions = new FirmwareComponentGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        return GlobalState.dispatch(firmwareComponentActions.list({
          limit,
          offset
        }));
      },
      getOption: async ({
        id
      }) => {
        const relationship = Relationships.getByPath('leverege.fotaApi.firmwareApplication');
        const firmwareComponentActions = new FirmwareComponentGroupDelegate({
          relationship,
          match: {
            params: {}
          }
        });
        if (firmwareComponentActions.getItem(id)) {
          return firmwareComponentActions.getItem(id);
        }
        return GlobalState.dispatch(firmwareComponentActions.get(id));
      }
    });
  }
};